import classNames from "classnames"
import { createElement, FC, HTMLProps } from "react"

export interface Props extends HTMLProps<HTMLElement> {
  as?: keyof JSX.IntrinsicElements
  theme?: "blue" | "green" | "red" | "yellow"
}

const Tag: FC<Props> = ({
  as = "div",
  children,
  className,
  theme = "blue",
  ...props
}) => {
  return (
    createElement(
      as,
      {
        className: classNames(
          "tag",
          `tag--${theme}`,
          className
        ),
        ...props
      },
      children
    )
  )
}

export default Tag
